module.exports = __webpack_public_path__ + "static/img/ios_ar.322bbac9.png";